import { render, staticRenderFns } from "./BinsView.vue?vue&type=template&id=3313709e"
import script from "./BinsView.vue?vue&type=script&lang=js"
export * from "./BinsView.vue?vue&type=script&lang=js"
import style0 from "./BinsView.vue?vue&type=style&index=0&id=3313709e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports